export default __webpack_public_path__ + "static/tag-do-1-dark-cbe257d65d1cfc919aaecf3b10e1a381.png";